export default __webpack_public_path__ + "static/media/unionpay.51d89c84.svg";